<template>
  <div>

    <div class="columns">
      <div class="column">

        <div class="buttons is-right">
          <a class="button is-info is-small" :href="url" target="_blank">
            <b-icon icon="open-in-new" />
          </a>

          <button class="button is-small" @click="$emit('removeLink', link)">
            <b-icon icon="delete" />
          </button>
        </div>

      </div>
    </div>

    <div class="columns">

      <div class="column">

        <b-field label="URL">
            <b-input icon="link-variant"
                     aria-label="URL"
                     v-model="url"
                     @input="$emit('urlInput', url)"
                     type="text"
                     placeholder="Destination" />
        </b-field>

        <b-field label="CTA">
            <b-input icon="fountain-pen-tip"
                     aria-label="CTA"
                     v-model="cta"
                     @input="$emit('ctaInput', cta)"
                     type="text"
                     placeholder="Call To Action" />
        </b-field>

        <b-field label="Coupon">
          <b-input icon="tag"
                   v-model="coupon"
                   @input="$emit('couponInput', coupon)"
                   type="text"
                   placeholder="coupon" />
        </b-field>

      </div>

      <div class="column">
        <b-field label="Price">
          <b-numberinput v-model.number="price"
                         step="0.01"
                         @input="$emit('priceInput', price)" />
        </b-field>

        <b-field label="CBFID">
          <b-input icon="source-branch" v-model="cbfid" @input="$emit('cbfidInput', cbfid)" type="text" placeholder="cbfid" />
        </b-field>

        <b-field label="Processor">
          <b-select icon="bank" v-model="processor" @input="$emit('processorInput', processor)">
            <option value="clickbank">ClickBank</option>
            <option value="samcart">SamCart</option>
            <option value="Other">Other</option>
          </b-select>
        </b-field>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    link: Object,
  },
  data() {
    return {
      cta: '',
      url: '',
      price: null,
      processor: null,
      coupon: null,
      cbfid: null,
    }
  },
  mounted() {
    this.cta = this.link.cta;
    this.url = this.link.url;
    this.price = this.link.price || null;
    this.processor = this.link.processor || null;
    this.coupon = this.link.coupon || null;
    this.cbfid = this.link.cbfid || null; // The flow ID that can upsell this payment link.
  }
}
</script>